import {
  Dialog,
  DialogClose,
  DialogContent as CoreDialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
  DialogTrigger,
} from "@vortexnyc/vortex-core/ui";
import type { ComponentProps } from "react";

function DialogContent({
  noCloseButton,
  noScrollPrevention: _noScrollPrevention,
  showCloseButton,
  ...props
}: ComponentProps<typeof CoreDialogContent> & {
  noCloseButton?: boolean;
  noScrollPrevention?: boolean;
}) {
  return (
    <CoreDialogContent
      showCloseButton={showCloseButton ?? !noCloseButton}
      {...props}
    />
  );
}

export {
  Dialog,
  DialogPortal,
  DialogOverlay,
  DialogClose,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
};
